import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const Loading = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
      }}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />}
        size="large"
      />
      <Title level={3} style={{ marginTop: 16 }}>
        Loading, please wait...
      </Title>
      <Text type="secondary">Almost there! Preparing your content...</Text>
    </div>
  );
};

export default Loading;
